import type { MutationTree } from 'vuex';
import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';
import type { EntityState } from './entity.types';
import { EntityMutation } from './entity.types';

export const mutations: MutationTree<EntityState> = {
  [EntityMutation.SetEntity](state: EntityState, entity: Entity) {
    state.entity = entity;
  },
};
